import * as React from 'react'

import { inject, observer } from 'mobx-react'

import DesktopEventStore from '~/client/src/desktop/stores/EventStore/DesktopEvents.store'

import AttachmentFilter from './AttachmentFilter'
import AttachmentFilterStore from './AttachmentFilter.store'

interface IProps {
  attachmentFilterStore: AttachmentFilterStore
  resetAllFilters: () => void
  eventsStore?: DesktopEventStore
}

const AttachmentsFilters: React.FC<IProps> = observer(
  ({ eventsStore, attachmentFilterStore, resetAllFilters }) => {
    return (
      <AttachmentFilter
        store={attachmentFilterStore}
        forceCloseMap={{}}
        eventsStore={eventsStore}
        filters={eventsStore.appState.attachmentsFilters}
        resetAllFilters={resetAllFilters}
        activeViewId="attachments"
      />
    )
  },
)
export default inject('eventsStore')(AttachmentsFilters)
